/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientTicketLogControllerFindAll } from '../fn/client-ticket-log/client-ticket-log-controller-find-all';
import { ClientTicketLogControllerFindAll$Params } from '../fn/client-ticket-log/client-ticket-log-controller-find-all';
import { clientTicketLogControllerSearchOffset } from '../fn/client-ticket-log/client-ticket-log-controller-search-offset';
import { ClientTicketLogControllerSearchOffset$Params } from '../fn/client-ticket-log/client-ticket-log-controller-search-offset';
import { ClientTicketLogDto } from '../models/client-ticket-log-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientTicketLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientTicketLogControllerFindAll()` */
  static readonly ClientTicketLogControllerFindAllPath = '/api/client-ticket-log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketLogControllerFindAll$Response(params?: ClientTicketLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketLogDto>> {
    return clientTicketLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketLogControllerFindAll(params?: ClientTicketLogControllerFindAll$Params, context?: HttpContext): Observable<ClientTicketLogDto> {
    return this.clientTicketLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientTicketLogDto>): ClientTicketLogDto => r.body)
    );
  }

  /** Path part for operation `clientTicketLogControllerSearchOffset()` */
  static readonly ClientTicketLogControllerSearchOffsetPath = '/api/client-ticket-log/search/offset';

  /**
   * 고객사 이용권 오프셋 기반 조회.
   *
   * 고객사 이용권 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketLogControllerSearchOffset$Response(params: ClientTicketLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientTicketLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 오프셋 기반 조회.
   *
   * 고객사 이용권 로그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketLogControllerSearchOffset(params: ClientTicketLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientTicketLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
